import { createAction } from '@reduxjs/toolkit';
import { RiskTemplateCatalogEntry } from '@Types/riskTemplateCatalog.types';

export interface GetRiskTemplateCatalogPayload {
	systemTypeId: string;
	assetTypeId: string;
}

export const getRiskTemplateCatalog =
	createAction<GetRiskTemplateCatalogPayload>(
		'riskTemplateCatalog/getRiskTemplateCatalog',
	);
export const getRiskTemplateCatalogResolved = createAction<
	RiskTemplateCatalogEntry[]
>('riskTemplateCatalog/getRiskTemplateCatalogResolved');
export const getRiskTemplateCatalogRejected = createAction(
	'riskTemplateCatalog/getRiskTemplateCatalogRejected',
);
